import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export const OrderConfirmation = ({ orderId, onClose }) => {
  const link = `${window.location.origin}/pedido/${orderId}`;
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Link de acompanhamento copiado!");
    } catch {
      toast.error("Não consegui copiar — selecione o link manualmente");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
      className="py-6 text-center"
      data-testid="order-confirmation"
    >
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-400/15">
        <Check className="h-8 w-8 text-emerald-400" strokeWidth={3} />
      </span>
      <h3 className="mt-5 font-syne text-2xl font-extrabold text-white">Pedido recebido!</h3>
      <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-purple-200/80">
        Seu pedido foi para o WhatsApp da loja. Guarde o link abaixo para acompanhar
        o status em tempo real — a gente também te avisa no seu WhatsApp quando o
        pedido sair pra entrega.
      </p>

      <div className="mt-6 rounded-2xl border border-purple-500/25 bg-white/5 p-5">
        <p className="font-grotesk text-[10px] font-bold uppercase tracking-[0.25em] text-amber-400">
          Link de acompanhamento
        </p>
        <p
          data-testid="tracking-link-text"
          className="mt-2 break-all text-xs leading-relaxed text-purple-100"
        >
          {link}
        </p>
        <div className="mt-4 flex gap-2.5">
          <button
            type="button"
            data-testid="copy-tracking-link-button"
            onClick={copy}
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-purple-400/40 py-3 text-xs font-bold text-purple-100 transition-colors duration-200 hover:border-amber-300 hover:text-amber-300"
          >
            <Copy className="h-3.5 w-3.5" />
            {copied ? "Copiado!" : "Copiar link"}
          </button>
          <a
            data-testid="view-tracking-link"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-1 items-center justify-center gap-2 rounded-full bg-emerald-400 py-3 text-xs font-bold text-[#1E053B] transition-transform duration-200 hover:scale-[1.03] active:scale-95"
          >
            <ExternalLink className="h-3.5 w-3.5" />
            Acompanhar
          </a>
        </div>
      </div>

      <button
        type="button"
        data-testid="confirmation-close-button"
        onClick={onClose}
        className="mt-6 rounded-full border border-purple-500/30 px-8 py-3 text-xs font-bold text-purple-100 transition-colors duration-200 hover:border-emerald-400 hover:text-emerald-300"
      >
        Fechar
      </button>
    </motion.div>
  );
};
